// Polyfills for React 18 compatibility

import ReactDOM from 'react-dom'

// Polyfill for util module functions that are causing browser compatibility issues
if (typeof window !== 'undefined' && !window.util) {
  window.util = {
    debuglog: function(section) {
      return function(...args) {
        if (import.meta.env.DEV) {
          console.debug(`[${section}]`, ...args)
        }
      }
    },
    inspect: function(obj) {
      if (obj === null) return 'null'
      if (obj === undefined) return 'undefined'
      if (typeof obj === 'string') return `'${obj}'`
      if (typeof obj === 'number' || typeof obj === 'boolean') return String(obj)
      if (typeof obj === 'function') return `[Function: ${obj.name || 'anonymous'}]`
      if (Array.isArray(obj)) {
        return `[${obj.map(item => window.util.inspect(item)).join(', ')}]`
      }
      if (typeof obj === 'object') {
        try {
          return JSON.stringify(obj, null, 2)
        } catch {
          return '[Object]'
        }
      }
      return String(obj)
    }
  }
}

// React 18 has findDOMNode, so no polyfill needed

export default {}
